export default __webpack_public_path__ + "static/media/6.d197a505.jpg";